import { useContext } from 'react';
import { GlobalContext } from '../../../library/Core/GlobalContext';
import { DomainElement } from '../../../library/Core/SmartTypes';
import { InstituteSearchCriteria } from './BurnerAnalysisService';

interface Props {
    criteria: InstituteSearchCriteria;
    onChange: (next: InstituteSearchCriteria) => void;
    onClearAll: () => void;
}

const TITLES: Record<keyof InstituteSearchCriteria, string> = {
    instituteGroupId: 'Group',
    instituteId: 'Institute',
    clientType: 'Client',
    instituteTypeCode: 'Type',
};

const FiltersApplied = ({ criteria, onChange, onClearAll }: Props) => {
    const { globalState } = useContext(GlobalContext);
    const domain = globalState?.domain;

    const lookup = (categoryCode: string, value: string): string => {
        const list = (domain?.get(categoryCode) as DomainElement[]) ?? [];
        return list.find((d) => String(d.code) === String(value))?.value ?? value;
    };

    const resolveLabel = (key: keyof InstituteSearchCriteria, value: string): string => {
        if (!value) return '';
        if (key === 'instituteGroupId') return lookup('SCHOOL_GROUP', value);
        if (key === 'instituteId') return lookup('INSTITUTE_DOMAIN', value);
        if (key === 'clientType') return lookup('SCHOOL_CLIENT_STATUS_CODE', value);
        if (key === 'instituteTypeCode') return lookup('INSTITUTE_TYPE_CODE', value);
        return value;
    };

    const chips = (Object.keys(criteria) as Array<keyof InstituteSearchCriteria>)
        .filter((key) => criteria[key] && String(criteria[key]).length > 0)
        .map((key) => ({ key, title: TITLES[key], value: resolveLabel(key, String(criteria[key])) }));

    if (chips.length === 0) return null;

    return (
        <div className="d-flex flex-wrap align-items-center gap-2 mb-3">
            {chips.map((chip) => (
                <span
                    key={chip.key}
                    className="badge rounded-pill px-3 py-2"
                    style={{ background: '#185fa5', color: '#e6f1fb', fontWeight: 500 }}>
                    {chip.title}: {chip.value}
                    <span
                        role="button"
                        className="ms-2"
                        style={{ cursor: 'pointer' }}
                        onClick={() => onChange({ ...criteria, [chip.key]: '' })}>
                        &times;
                    </span>
                </span>
            ))}
            <a role="button" className="text-danger font-13 font-500 ms-2" onClick={onClearAll}>
                Clear all
            </a>
        </div>
    );
};

export default FiltersApplied;
